export interface Theme {
  primary: string;
  text: string;
  textSecondary: string;
  backgroundInput: string;
  white: string;
  error: string;
  warning: string;
  border: string;
  disabled: string;
}

// Default theme — primary, secondary, and text will later be fetched from API
const defaultTheme: Theme = {
  primary: '#004481',
  text: '#2f3044',
  textSecondary: '#848484',
  backgroundInput: '#f3f6f9',
  white: '#ffffff',
  error: '#ff0000',
  warning: '#ff9500',
  border: '#dde4ea',
  disabled: '#aaa'
};

export default defaultTheme;
